import { render } from "./AttendanceMonitoring.vue?vue&type=template&id=12c061a7&ts=true"
import script from "./AttendanceMonitoring.vue?vue&type=script&lang=ts"
export * from "./AttendanceMonitoring.vue?vue&type=script&lang=ts"

import "./AttendanceMonitoring.vue?vue&type=style&index=0&id=12c061a7&lang=css"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__